var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "global-responsive-image" },
    [
      _vm.lazy && _vm.responsiveImage.imagePreview
        ? [
            _vm.responsiveImage.image &&
            _vm.responsiveImage.imagePreview &&
            _vm.responsiveImage.imageProperties
              ? _c(
                  "picture",
                  { ref: "image", staticClass: "vue-image sal-image preview" },
                  [
                    _vm.responsiveImage.image.xl && _vm.responsiveImage.image.xl
                      ? _c("source", {
                          attrs: {
                            srcset: _vm.responsiveImage.imagePreview.xl,
                            "data-src": _vm.responsiveImage.image.xl,
                            media: "(min-width: 1400px)",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.responsiveImage.image.lg && _vm.responsiveImage.image.lg
                      ? _c("source", {
                          attrs: {
                            srcset: _vm.responsiveImage.imagePreview.lg,
                            "data-src": _vm.responsiveImage.image.lg,
                            media: "(min-width: 1000px)",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.responsiveImage.image.md && _vm.responsiveImage.image.md
                      ? _c("source", {
                          attrs: {
                            srcset: _vm.responsiveImage.imagePreview.md,
                            "data-src": _vm.responsiveImage.image.md,
                            media: "(min-width: 768px)",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.responsiveImage.image.xs && _vm.responsiveImage.image.xs
                      ? _c("source", {
                          attrs: {
                            srcset: _vm.responsiveImage.imagePreview.xs,
                            "data-src": _vm.responsiveImage.image.xs,
                            media: "(max-width: 767px)",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.responsiveImage.imagePreview.xl &&
                    _vm.responsiveImage.image.xl
                      ? _c("img", {
                          staticClass: "img-responsive img-fluid",
                          attrs: {
                            src: _vm.responsiveImage.imagePreview.xl,
                            "data-src": _vm.responsiveImage.image.xl,
                            alt: _vm.responsiveImage.imageProperties.alt,
                            title: _vm.responsiveImage.imageProperties.title,
                          },
                          on: {
                            load: function ($event) {
                              return _vm.$emit("load", $event)
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                )
              : void 0,
          ]
        : [
            _vm.responsiveImage.image && _vm.responsiveImage.imageProperties
              ? _c(
                  "picture",
                  { ref: "image", staticClass: "vue-image sal-image" },
                  [
                    _vm.responsiveImage.image.xl
                      ? _c("source", {
                          attrs: {
                            srcset: _vm.responsiveImage.image.xl,
                            media: "(min-width: 1400px)",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.responsiveImage.image.lg
                      ? _c("source", {
                          attrs: {
                            srcset: _vm.responsiveImage.image.lg,
                            media: "(min-width: 1000px)",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.responsiveImage.image.md
                      ? _c("source", {
                          attrs: {
                            srcset: _vm.responsiveImage.image.md,
                            media: "(min-width: 768px)",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.responsiveImage.image.xs
                      ? _c("source", {
                          attrs: {
                            srcset: _vm.responsiveImage.image.xs,
                            media: "(max-width: 767px)",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.responsiveImage.image.xl
                      ? _c("img", {
                          staticClass: "img-responsive img-fluid",
                          attrs: {
                            src: _vm.responsiveImage.image.xl,
                            alt: _vm.responsiveImage.imageProperties.alt,
                            title: _vm.responsiveImage.imageProperties.title,
                          },
                          on: {
                            load: function ($event) {
                              return _vm.$emit("load", $event)
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                )
              : void 0,
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }